<template>
  <div class="text-center">
    <div class="hello">
      <button :class="recording?  `Rec`: `record_btn m-2`" @click="start" :disabled="recording">
        <span key="fa-microphone">
          <i class="fas fa-microphone"></i>
        </span>
      </button>
      <button class="record_btn" @click="end" :disabled="!recording">
        <span key="fa-stop">
          <i class="fas fa-stop"></i>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
  export default {
    name: "voice",
    props: {
      master_audience_code: String,
    },
    data() {
      return {
        recordId: null,
        recording: false,
        client: null,
        stream: null,
        countDown: 100
      };
    },
    methods: {
      cancel() {

      },
      start() {
        this.startClient();
        this.recording = true;
      },
      end() {
        this.recording = false;
        this.Stream.end();
        this.client.close();
        this.client = null;
      },
      time_convert(timestamp) {
          let time =+ timestamp
        var date = new Date(time);

        return date.getHours()+ ":"+date.getMinutes()+ ":"+date.getSeconds()
      },
      prettyTime(t) {
        let minutes = Math.floor(t / 60);
        if (minutes < 10) minutes = '0' + minutes;
        let seconds = Math.floor(t % 60);
        if (seconds < 10) seconds = '0' + seconds;
        return `${minutes}:${seconds}`;
      },
      onProcess(e) {
        if (!this.recording) return;
        var left = e.inputBuffer.getChannelData(0);
        this.Stream.write(this.convertoFloat32ToInt16(left));
      },
      success(e) {
        let audioContext = window.AudioContext || window.webkitAudioContext;
        let context = new audioContext();

        // the sample rate is in context.sampleRate
        let audioInput = context.createMediaStreamSource(e);

        let bufferSize = 256;
        let recorder = context.createScriptProcessor(bufferSize, 1, 1);

        recorder.onaudioprocess = this.onProcess;

        audioInput.connect(recorder);
        recorder.connect(context.destination);
      },
      convertoFloat32ToInt16(buffer) {
        let l = buffer.length;
        let buf = new Int16Array(l);

        while (l--) {
          buf[l] = buffer[l] * 0xffff; //convert to 16 bit
        }
        return buf.buffer;
      },
      openClient() {
        this.Stream = this.client.createStream({
          id: this.master_audience_code
        });

        if (!navigator.getUserMedia)
          navigator.getUserMedia =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;

        if (navigator.getUserMedia) {
          navigator.getUserMedia({
            audio: true
          }, this.success, function (e) {
            alert("Error capturing audio. " + e);
          });
        } else alert("getUserMedia not supported in this browser.");

        // this.recording = false;
      },
      startClient() {
        if (!this.client) {
          this.client = new BinaryClient("wss://api.jazb.judiciarybar.ir:9001");
          // this.client = new BinaryClient("ws://localhost:9001");

          this.client.on("open", this.openClient);
        }
      },
      countDownTimer() {
        if (this.countDown > 0) {
          setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
          }, 1000)
        }
      },
      dateTime() {
        let currentdate = new Date();
        let datetime = currentdate.getDate() + "/" +
          (currentdate.getMonth() + 1) + "/" +
          currentdate.getFullYear() + " - " +
          currentdate.getHours() + ":" +
          currentdate.getMinutes() + ":" +
          currentdate.getSeconds();

        this.recordId = `  صوت مصاحبه توسط استاد  ${this.master_audience_code}${datetime} `
      }
    },

    created() {
      // this.startClient();
      this.dateTime()
      // this.countDownTimer()
    },
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .record_btn {
    width: 50px;
    height: 50px;

    font-size: 25px;
    color: #e74c3c;
    background: none;
    border: 2px solid #e74c3c;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.15s linear;
  }

  .Rec {
    width: 50px;
    height: 50px;

    font-size: 25px;
    color: #e74c3c;
    background: none;
    border: 2px solid #e74c3c;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.15s linear;



  }

  .record_btn:hover {
    transition: 0.15s linear;
    transform: scale(1.05);
  }

  .record_btn:active {
    background: #f5f5f5;
  }

  .Rec {
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, .3);
    }

    65% {
      box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, .3);
    }

    90% {
      box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, 0);
    }
  }

</style>
